import { LOCAL_STORAGE_CONSTANT } from '@shared/constants/local-storage-constant';
import { CurrentStore } from '@shared/models/store.model';

export class StoreStorageUtil {
  public static retrieveStore(): CurrentStore {
    const storeData = localStorage.getItem(LOCAL_STORAGE_CONSTANT.CURRENT_STORE);
    let parsedData: CurrentStore;
    if (storeData) {
      parsedData = JSON.parse(storeData);
    }
    return parsedData;
  }
  public static retrieveStoreNo(): string {
    return this.retrieveStore().storeNo;
  }

  public static retrieveStoreCode(): string {
    return this.retrieveStore().storeCode;
  }
}
